import { toast } from "react-toastify";
import useRetryMarketplacePayment from "../libs/useRetryMarketplacePayment";
import { isPayOnDeliveryOrder } from "../libs/orderDisplayUtils";

export const canRetryPayment = (order) => {
  if (!order || order.status === "Canceled") return false;
  if (isPayOnDeliveryOrder(order)) return false;
  if (order.paymentStatus === "paid") return false;
  return ["pending", "failed"].includes(order.paymentStatus);
};

const RetryPaymentButton = ({ order, className = "order-action--primary", label = "Retry payment" }) => {
  const { mutate, isLoading } = useRetryMarketplacePayment();

  if (!canRetryPayment(order)) return null;

  const handleRetry = () => {
    mutate(
      { orderId: order._id },
      {
        onSuccess: (data) => {
          const link = data.paymentLink || data.link;
          if (link) {
            window.location.href = link;
          } else {
            toast.error("Could not get payment link");
          }
        },
        onError: (err) => toast.error(err.response?.data?.message || "Could not start payment"),
      }
    );
  };

  return (
    <button type="button" className={className} onClick={handleRetry} disabled={isLoading}>
      {isLoading ? "Redirecting…" : label}
    </button>
  );
};

export default RetryPaymentButton;
